var _a;
import { AiAgentFeature } from './AiAgentFeature';
const AI_AGENT_LAYOUT = 'AiAgent';
const AI_AGENT_ROUTE = 'auth.application.detail.aiAgents.home';
export class AiAgentService {
    static $inject = ['CurrentApplicationService'];
    constructor(CurrentApplicationService) {
        this.CurrentApplicationService = CurrentApplicationService;
    }
    async checkAiAgentAsync() {
        this.application = await this.CurrentApplicationService.fetchApplication();
        return this.application.layout === AI_AGENT_LAYOUT;
    }
}
_a = AiAgentService;
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
AiAgentService.$inject = ['CurrentApplicationService'];
AiAgentService.blockAiAgentAccess = [
    '$state',
    'application',
    '$translate',
    'ngToast',
    async ($state, application, $translate, ngToast) => {
        const allowAiAgentAccessDefaultScreens = await AiAgentFeature.allowAiAgentAccessDefaultScreensEnabled();
        if (!allowAiAgentAccessDefaultScreens && application.layout === AI_AGENT_LAYOUT) {
            $state.go(AI_AGENT_ROUTE, { shortName: application.shortName });
            const errorMsg67 = await $translate('utils.errorMsg.67');
            ngToast.danger(errorMsg67);
        }
    },
];
